<template>
  <v-layout>
    <v-flex xs12 sm3>
      <v-menu
        ref="startDateField"
        :close-on-content-click="false"
        :nudge-right="40"
        v-model="startDateField"
        :return-value.sync="start"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          :value="startFormatted"
          :label="$t('private_global_start')"
          :min="minimumDate"
          required
          :rules="startRules"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker
          v-model="start"
          :first-day-of-week="firstDayOfWeek"
          color="primary"
          :max="maximumDate"
          @input="$refs.startDateField.save(start)"
          :min="today"
          :locale="langSelected.langIso"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 sm3 offset-sm1>
      <v-menu
        ref="endDateField"
        :close-on-content-click="false"
        :nudge-right="40"
        v-model="endDateField"
        :return-value.sync="end"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field slot="activator" :value="endFormatted" :label="$t('private_global_end')" :min="minimumDate" prepend-icon="event" readonly :append-icon="closeIcon" @click:append="clearEnd"></v-text-field>
        <v-date-picker
          v-model="end"
          :first-day-of-week="firstDayOfWeek"
          color="primary"
          :min="minimumDate"
          @input="$refs.endDateField.save(end)"
          :locale="langSelected.langIso"
        ></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment';

const onDatesSelectedEvent = 'on-dates-selected';

export default {
  name: 'VuetifyFromToDateSelector',
  props: ['langSelected', 'propStart', 'propEnd', 'allowSameStartEnd', 'allowNullEnd'],
  components: {},
  computed: {
    startFormatted() {
      let result = '';
      if (this.start !== null) {
        result = moment(this.start).format('L');
      }
      return result;
    },
    endFormatted() {
      let result = '';
      if (this.end !== null) {
        result = moment(this.end).format('L');
      }
      return result;
    },
    minimumDate() {
      if (this.start !== null) {
        if (!this.allowSameStartEnd) {
          return moment(this.start).add({
            days: 1
          }).format('YYYY-MM-DD');
        } else {
          return moment(this.start).format('YYYY-MM-DD');
        }
      }
      return moment().format('YYYY-MM-DD');
    },
    maximumDate() {
      if (this.allowSameStartEnd && this.end !== null) {
        return moment(this.end).format('YYYY-MM-DD');
      }
      return '2100-12-31';
    },
    today() {
      return moment().format('YYYY-MM-DD');
    },
    closeIcon() {
      if (this.allowNullEnd && this.end != null) {
        return 'close'
      } else {
        return ''
      }
    }
  },
  watch: {
    start: function(value) {
      if (this.start >= this.end) {
        this.end = null;
      }
      this.$emit(onDatesSelectedEvent, { start: this.start, end: this.end });
    },
    end: function(value) {
      this.$emit(onDatesSelectedEvent, { start: this.start, end: this.end });
    },
    propStart: function(value) {
      this.start = this.propStart;
    },
    propEnd: function(value) {
      this.end = this.propEnd;
    }
  },
  data() {
    return {
      startDateField: false,
      endDateField: false,
      firstDayOfWeek: moment()
        .isoWeekday(0)
        .isoWeekday(),
      start: null,
      end: null,
      startRules: [
        v => {
          if (typeof v === 'undefined') {
            return this.$i18n.t('private_validation_required_start');
          }
          return !!v || this.$i18n.t('private_validation_required_start');
        }
      ]
    };
  },
  created() {
    if (typeof this.propStart !== 'undefined') {
      this.start = this.propStart;
    }
    if (typeof this.propEnd !== 'undefined') {
      this.end = this.propEnd;
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    reset() {
      this.start = null;
      this.end = null;
      this.startDateField = false;
      this.endDateField = false;
    },
    clearEnd() {
      this.end = null;
      this.$emit(onDatesSelectedEvent, { start: this.start, end: this.end });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/commons/VuetifyFromToDateSelector.vue